export default __webpack_public_path__ + "static/media/book_3.7d865f1e.svg";